import React from 'react';

import NavIcons from './NavIcons';
import Logo from './Logo';
import ArrowDown from '../img/arrow-down.svg';

import { Link } from 'react-scroll';


function Header() {
	return (
		<header id="top">
			<div className="container">
				<Logo />
				<span className="header-dates">April 29-May 1, 2021</span>
				<span className="slogan">A design workshop for social impact</span>
				<NavIcons colorMode="dark" includeIcons />
				<button id="slideDown"><Link to="what" spy={true} smooth={true} duration={500}><img src={ArrowDown} alt="Arrow down" /></Link></button>
			</div>
		</header>)
}
export default Header;
